<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">PaxelRecycle - More Info</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Image (JPG/PNG)"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <b-row>
              <b-col class="text-primary mt-2">
                <i class="fas fa-paperclip"></i>&nbsp;
                <b>File (.png/.jpg)</b>
                <sup class="text-secondary pl-3"
                  >(2 Mb)&nbsp;(580px x 380px)</sup
                >
              </b-col>
              <b-col md="4" class="text-right" align="right">
                <input
                  type="file"
                  ref="fileJpg"
                  name="imagejpg"
                  data-vv-as="Image JPG/PNG"
                  v-validate="
                    !item.image_jpg
                      ? 'required|minimalDimensions:580,380|ratiolDimensions:580,380|size:2000|ext:jpg,png,gif,jpeg'
                      : 'minimalDimensions:580,380|ratiolDimensions:580,380|size:2000|ext:jpg,png,gif,jpeg'
                  "
                  style="display: none"
                  v-on:change="onChangeFileJpg()"
                />
                <b-button
                  @click="$refs.fileJpg.click()"
                  v-show="!item.image_jpg && !fileJpg"
                  variant="primary"
                  class="ml-5"
                  >Pilih File</b-button
                >
                <b-button
                  v-show="item.image_jpg || fileJpg"
                  variant="primary"
                  @click="modalJpg = !modalJpg"
                  class="mr-2"
                  >Pratinjau</b-button
                >
                <b-button
                  @click="$refs.fileJpg.click()"
                  v-show="item.image_jpg || fileJpg"
                  variant="outline-primary"
                  class
                  >Ubah File</b-button
                >
              </b-col>
            </b-row>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagejpg") }}
          </p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Image (Webp)"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <b-row>
              <b-col class="text-primary mt-2">
                <i class="fas fa-paperclip"></i>&nbsp;
                <b>File (.webp)</b>
                <sup class="text-secondary pl-3"
                  >(2 Mb)&nbsp;(580px x 380px)</sup
                >
              </b-col>
              <b-col md="4" class="text-right" align="right">
                <input
                  type="file"
                  ref="fileWebp"
                  name="imagewebp"
                  data-vv-as="Image Webp"
                  v-validate="
                    !item.image_webp
                      ? 'required|minimalDimensions:580,380|ratiolDimensions:580,380|size:2000|ext:webp'
                      : 'minimalDimensions:580,380|ratiolDimensions:580,380|size:2000|ext:webp'
                  "
                  style="display: none"
                  v-on:change="onChangeFileWebp()"
                />
                <b-button
                  @click="$refs.fileWebp.click()"
                  v-show="!item.image_webp && !fileWebp"
                  variant="primary"
                  class="ml-5"
                  >Pilih File</b-button
                >
                <b-button
                  v-show="item.image_webp || fileWebp"
                  variant="primary"
                  @click="modalWebp = !modalWebp"
                  class="mr-2"
                  >Pratinjau</b-button
                >
                <b-button
                  @click="$refs.fileWebp.click()"
                  v-show="item.image_webp || fileWebp"
                  variant="outline-primary"
                  class
                  >Ubah File</b-button
                >
              </b-col>
            </b-row>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagewebp") }}
          </p>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Image Alt Text"
            label-class="control-label"
            class="required"
            label-for="image-alt-text"
          >
            <input
              v-model="item.image_alt"
              v-validate="'required'"
              name="image_alt_Text"
              data-vv-as="Image Alt Text"
              id="image-alt-text"
              class="form-control"
              placeholder="Image Alt Text"
            />
            <b-form-invalid-feedback id="input-image_alt_Text-feedback">{{
              veeErrors.first("image_alt_Text")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Heading (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="heading-id"
          >
            <input
              v-model="item.heading.id"
              v-validate="'required'"
              name="heading_id"
              data-vv-as="Heading Bahasa"
              id="heading-id"
              class="form-control"
              placeholder="Heading in Bahasa"
            />
            <b-form-invalid-feedback id="input-heading_id-feedback">{{
              veeErrors.first("heading_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Heading (English)"
            label-class="control-label"
            class="required"
            label-for="heading-en"
          >
            <input
              v-model="item.heading.en"
              v-validate="'required'"
              name="heading_en"
              data-vv-as="Heading English"
              id="heading-en"
              class="form-control"
              placeholder="Heading in English"
            />
            <b-form-invalid-feedback id="input-heading_en-feedback">{{
              veeErrors.first("heading_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Sub Heading (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="sub-heading-id"
          >
            <input
              v-model="item.sub_heading.id"
              v-validate="'required'"
              name="sub_heading_id"
              data-vv-as="Sub Heading Bahasa"
              id="sub-heading-id"
              class="form-control"
              placeholder="Sub Heading in Bahasa"
            />
            <b-form-invalid-feedback id="input-sub_heading_id-feedback">{{
              veeErrors.first("sub_heading_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Sub Heading (English)"
            label-class="control-label"
            class="required"
            label-for="sub-heading-en"
          >
            <input
              v-model="item.sub_heading.en"
              v-validate="'required'"
              name="sub_heading_en"
              data-vv-as="Sub Heading English"
              id="sub-heading-en"
              class="form-control"
              placeholder="Sub Heading in English"
            />
            <b-form-invalid-feedback id="input-sub_heading_en-feedback">{{
              veeErrors.first("sub_heading_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Teks Tombol (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="item.button_text.id"
              name="button_text_id"
              data-vv-as="Teks Tombol Bahasa"
              class="form-control"
              placeholder="Teks Tombol in Bahasa"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_text_id") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Teks Tombol (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="item.button_text.en"
              name="button_text_en"
              data-vv-as="Teks Tombol English"
              class="form-control"
              placeholder="Teks Tombol English"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_text_en") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="URL Tombol"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required|url: {require_protocol: true }'"
              v-model="item.button_url"
              name="button_url"
              data-vv-as="URL Tombol"
              class="form-control"
              placeholder="Masukkan URL"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_url") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'PaxelRecycleMoreInfo' }">
            <b-button :disabled="loading" class="col-2 mr-3" variant="outline-secondary" size="lg">Batal</b-button>
          </router-link>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="col-2"
            size="lg"
          >
            Simpan
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalJpg" title="Preview Image" size="xl">
      <img
        v-show="!fileJpg"
        v-if="item.image_jpg"
        width
        height="400px"
        :src="item.image_jpg"
      />
      <img
        v-show="fileJpg"
        v-if="urlJpg"
        width
        height="400px"
        :src="urlJpg"
      />
    </b-modal>
    <b-modal v-model="modalWebp" title="Preview Image" size="xl">
      <img
        v-show="!fileWebp"
        v-if="item.image_webp"
        width
        height="400px"
        :src="item.image_webp"
      />
      <img
        v-show="fileWebp"
        v-if="urlWebp"
        width
        height="400px"
        :src="urlWebp"
      />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      item: {
        image_jpg: "",
        image_webp: "",
        image_alt: "",
        heading: {
          id: "",
          en: ""
        },
        sub_heading: {
          id: "",
          en: ""
        },
        button_text: {
          id: "",
          en: ""
        },
        button_url: "",
      },
      loading: false,
      modalJpg: false,
      modalWebp: false,
      fileJpg: "",
      fileWebp: "",
      urlJpg: "",
      urlWebp: "",
    }
  },
  beforeMount() {
    this.$store
        .dispatch("PaxelRecycleMoreInfoModule/getMoreInfo")
        .then(response => {
          const data = response.data.data
          if(response.data.data) {
            this.item = response.data.data
          } else {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: "Your data could not be fetched",
              showConfirmButton: false,
              timer: 1500
            });  
          }
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: "Your data data could not be fetched",
            showConfirmButton: false,
            timer: 1500
          });
        });
  },
  methods: {
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("image_jpg", this.fileJpg);
          formData.append("image_webp", this.fileWebp);
          formData.append("image_alt", this.item.image_alt);
          formData.append("heading_id", this.item.heading.id);
          formData.append("heading_en", this.item.heading.en);
          formData.append("sub_heading_id", this.item.sub_heading.id);
          formData.append("sub_heading_en", this.item.sub_heading.en);
          formData.append("button_text_id", this.item.button_text.id);
          formData.append("button_text_en", this.item.button_text.en);
          formData.append("button_url", this.item.button_url);
          this.$store
            .dispatch("PaxelRecycleMoreInfoModule/postMoreInfo", formData)
            .then((response) => {
              this.loading = false;
              this.$validator.reset();
              // this.$router.push({ name: "PaxelRecycleMoreInfo" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    onChangeFileJpg() {
      this.fileJpg = this.$refs.fileJpg.files[0];
      const input = this.$refs.fileJpg;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlJpg = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileWebp() {
      this.fileWebp = this.$refs.fileWebp.files[0];
      const input = this.$refs.fileWebp;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlWebp = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  }
};
</script>

<style>
</style>